import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

const LoaderContainer = styled('div')({
  height: '32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

const LoaderRoot = styled('div')({
  alignItems: 'center',
  backgroundColor: '#f9edbe',
  border: '1px solid #f0c36d',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: '2px',
  paddingTop: '4px',
  paddingLeft: '4px',
  paddingRight: '4px',
})

const LoaderLabel = styled('span')({
  marginRight: '8px',
})

const LoadingSmall = () => {
  return (
    <LoaderContainer>
      <LoaderRoot>
        <LoaderLabel>
          <Typography variant="body2" color="textSecondary" align="center">
            Fetching latest data
          </Typography>
        </LoaderLabel>
        <CircularProgress size={16} />
      </LoaderRoot>
    </LoaderContainer>
  )
}

export { LoadingSmall }
